import styled, { css } from 'styled-components';

export const StyledText = styled.p<{darkened?: boolean; strong?: boolean}>`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 14px;
  color: ${({ theme, darkened }) => darkened ? theme.colors.white : theme.colors.black};
  margin-top: 0;
  margin-bottom: 8px;
  line-height: ${({ theme }) => theme.P.lineHeight};
  ${({ strong }) => strong && css`
    font-weight: 600;
  `}
`;
